'use server'

import { resolveTenant } from './tenant'
import { getPostBySlug } from './queries'
import type { Post } from '@/payload-types'

/**
 * Server action per lo scroll infinito degli articoli correlati: carica on-demand
 * il post completo (depth 2, contenuto Lexical popolato) da renderizzare lato client
 * con <ArticleView>. Riusa getPostBySlug → stessi vincoli del rendering pubblico:
 * scoping per tenant (risolto dall'Host) + solo `published`. Nessun leak: ritorna
 * solo ciò che è già pubblicamente raggiungibile su /{slug}/.
 */
export async function loadStreamPost(slug: string): Promise<Post | null> {
  const tenant = await resolveTenant()
  return getPostBySlug(tenant.id, slug)
}
